import React from "react";
import Video from "../../../common/Video";
import * as styles from "./Video.module.scss";

const VideoSection = () => {
  return (
    <div className={styles.videoSection}>
      <div>
        <h6>
          Se hvordan man bruger Multi-Regnskab <br />i et simpelt holdingselskab
        </h6>
        <Video
          videoSrcURL="https://www.youtube.com/embed/27s-e61O9BQ"
          videoTitle="Bogføring og årsrapport i et simpelt holdingselskab"
        />
      </div>
    </div>
  );
};

export default VideoSection;
